import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';
import { useFetchOnboardingFilterOptionSearchMutation } from '@features/trend-research/api/onboardingApi';

const TrendComposition = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [search, setSearch] = useState('');
	const debounceSearch = useDebouncedCallback((text) => setSearch(text), 500);
	const [fetchOnboardingFilterOptionSearch] = useFetchOnboardingFilterOptionSearchMutation();

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.TREND_RESEARCH]: dependentFilterList?.keyCompositionList
	};

	const onFetchData = async () => {
		let responseData = filterData[filterPageName];
		responseData = responseData?.map((item) => {
			return { id: item.name, name: item.name, count: item?.count };
		});
		setAllData(responseData);
		setData(responseData);
	};

	// const handleSearch = (e) => {
	// 	let searchResult = e.target.value
	// 		? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
	// 		: allData;
	// 	setData(searchResult);
	// };

	useEffect(() => {
		if (search) {
			(async () => {
				const data = await fetchOnboardingFilterOptionSearch({
					source: 'BRAND',
					requestBody: {},
					filterType: 'KEY_COMPOSITION',
					filterSearch: search
				});
				let responseData = data?.data?.map((item) => {
					return { id: item.name, name: item.name, count: item?.count };
				});
				setData(responseData);
			})();
		} else {
			setData(allData);
		}
	}, [search]);

	const handleSearch = async (e) => {
		debounceSearch(e.target.value);
	};

	return (
		<>
			<FilterName type="TREND_COMPOSITION" />
			<Checkbox data={data} type="TREND_COMPOSITION" handleSearch={handleSearch} />
		</>
	);
};

export default TrendComposition;
